import {
  useInternalEventTemplateDownload,
  useInternalEventTemplateVersionRetrieveSuspense,
} from "gen/endpoints/internal/internal";
import { CeleryWorkflowStatus } from "gen/model/celeryWorkflowStatus";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "shared/components/toast/useToast";
import { downloadFileBlob } from "shared/utils/utils";

export const getCeleryWorkflowStatus = (
  celeryWorkflowId: string | null | undefined,
  workflowStatuses: Map<string, CeleryWorkflowStatus>,
): CeleryWorkflowStatus | undefined => {
  if (!celeryWorkflowId) {
    return undefined;
  }

  return workflowStatuses.get(celeryWorkflowId);
};

export const useDownloadEventTemplate = (templateVersionId: string) => {
  const { t } = useTranslation(["common"]);
  const { showToast, showErrorToast } = useToast();

  const { mutateAsync: downloadEventTemplate } =
    useInternalEventTemplateDownload({
      request: {
        timeout: 60_000,
      },
    });

  const { data: templateData } =
    useInternalEventTemplateVersionRetrieveSuspense(templateVersionId);

  const downloadTemplate = useCallback(async () => {
    try {
      const fileDownload = await downloadEventTemplate({
        eventTemplateVersionId: templateVersionId,
      });
      const date = new Date().toISOString().slice(0, 10);
      const fileName = templateData.name + date + ".json";
      downloadFileBlob(fileDownload, fileName);
      showToast({
        message: t("common:downloadSuccess"),
        variant: "success",
      });
    } catch (err) {
      showErrorToast(err);
    }
  }, [
    downloadEventTemplate,
    showErrorToast,
    showToast,
    t,
    templateData.name,
    templateVersionId,
  ]);
  return downloadTemplate;
};
